import React from 'react';
import { useIntl } from '@kamernet/core/Intl';
import getConfig from 'next/config';
import GoogleMap, { Props as MapProps } from 'google-map-react';
import { CustomMapStyles } from './MapTheme';

const { publicRuntimeConfig } = getConfig();
type Props = {
  children: React.ReactNode;
  options: MapProps['options'];
} & MapProps;

export const KnGoogleMap = ({ children, options, ...rest }: Props) => {
  const { locale } = useIntl();
  return (
    <GoogleMap
      {...rest}
      bootstrapURLKeys={{
        key:
          publicRuntimeConfig.GOOGLE_MAP_PUBLIC_KEY ||
          'AIzaSyCwwWCqN-3P0hlql9G8ERz6ZIqpWX0e5BU',
        language: locale,
      }}
      options={{
        ...options,
        styles: CustomMapStyles,
        zoomControlOptions: {
          position: 3,
        },
        disableDoubleClickZoom: true,
      }}
    >
      {children}
    </GoogleMap>
  );
};
